import {useEffect} from 'react';
import {
    useGetUserProfile,
    ClientUserProfile
} from '../api/user/useGetUserProfile.ts';

interface UserProfileUpdaterProps {
    onUpdate: (profile: ClientUserProfile | null) => void;
}

export function UserProfileUpdater({onUpdate}: UserProfileUpdaterProps) {
    const {data: profileData, isSuccess} = useGetUserProfile();

    useEffect(() => {
        if (!isSuccess) {
            return;
        }

        // The endpoint answers 200 with an empty-roles stub when the request
        // carried no valid identity. Publishing that stub would satisfy the
        // "profile loaded" gate in AuthProvider and let role-gated routes
        // evaluate an empty role list, so it is treated as "no profile".
        onUpdate(profileData?.isAuthenticated ? profileData : null);
    }, [profileData, isSuccess, onUpdate]);

    return null;
}
